import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort, pick } from "@nosto/preact"
import { sortOptions } from "../config"

import SelectedFilters from "./SelectedFilters"
import Select from "./elements/Select"

export default function Toolbar() {
    const { loading, query, response, pageType } = useAppState();
    const { activeSort, setSort } = useSort(sortOptions);
    const selectedFiltersCount = useSelectedFiltersCount();
    const docCount = response.products?.total ?? 0
    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    const handleSortChange = event => {
        setSort(event.target.value)
    };

    return (
        <div class="ns-header-controls facets facets-vertical-sort no-js-hidden">
            <div class="facets-vertical-form">
                
                {/* Sort */}
                <div class="facet-filters sorting caption"> 
                    <div class="facet-filters__field">
                        <h2 class="facet-filters__label caption-large text-body visually-hidden">
                            <label for="SortBy">Ordenar por:</label>
                        </h2>
                        <Select
                            value={activeSort}
                            onChange={e => handleSortChange(e)}
                            className="facet-filters__sort select-custom"
                            options={options}
                            label={"Sort by"}
                        />
                    </div>
                </div>

                {/* Mobile */}
                <SelectedFilters 
                    className="active-facets--mobile-outside-of-drawer medium-hide large-up-hide" 
                />

                <div class="product-count-vertical light" role="status">
                  <h2 class="product-count__text text-body">
                    <span id="ProductCountDesktop" data-nosto-element="totalResults">
                        {docCount} {docCount > 1 ? 'productos' : 'producto'}
                    </span>
                  </h2>
                </div>

            </div>
        </div>
    )
}